/*
 * @Author: showangjing showangjing@didiglobal.com
 * @Date: 2023-04-24 11:22:26
 * @LastEditors: liuziwei
 * @LastEditTime: 2023-08-14 10:52:46
 * @FilePath: /fe-eshotel/src/components/notice/noticeTip.mpx
 * @Description: 公告提示条
 */
 
<template>
  <view wx:if="{{titleText && titleText.length}}" bindtap="onClick">
    <view class="tips-main {{type==='order'?'order':''}}">
      <view class="tips-left">
        <view wx:if="{{noticeTitle}}" class="tips-title">{{noticeTitle}}</view>
        <view class="tips-content">{{ titleText }}</view>
      </view>
      <view class="tips-right">
        <image class="angle-right" src="https://ut-static.udache.com/webx/sfc/SurrbhwdBTSNdfKCJ6aCW.png" />
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    name: 'EpidemicTip',
    props: {
      color: {
        type: String,
        value: '#333333;'
      },
      size: {
        type: String,
        value: '20'
      },
      titleText: {
        type: String,
        value: ''
      },
      noticeTitle: {
        type: String,
        value: ''
      },
      type: {
        type: String,
        value: 'list'
      }
    },
    data() {},
    computed: {},
    watch: {},
    methods: {
      onClick() {
        this.$trigger('click')
      }
    },
    mounted() {}
  })
</script>

<style lang="stylus" scoped>
  .tips-main
    height 33px
    box-sizing border-box
    display flex
    align-items center
    background #FFF0EE
    margin 0 8px 8px
    font-family PingFangSC-Regular
    font-size 12px
    border-radius 8px
    line-height 14px
    &.order
      margin 0
      color #333333
      .tips-content
        color #222
  .tips-icon
    margin-right 4px
  .tips-left
    width calc(100% - 40px)
    font-weight normal
    display flex
    margin-left 12px
  .tips-title
    flex none
    color #FF4129
    white-space nowrap
    text-overflow ellipsis
    margin-right 4px
  .tips-content
    flex 1
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
    color #FF6221
  .tips-right
    width 20px
    margin 0 4px
    line-height 20px
    text-align center
    align-content center
    .angle-right
      width 12px
      height 12px
</style>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>